export default __webpack_public_path__ + "static/media/Feature6.184e0ba0.svg";